
<div class="footer-newsletter"  *ngIf="siteService.siteSetting?.socialMedia">
    <ng-container *ngIf="!siteService.siteSetting.companyId">
        <!-- <h5 class="footer-newsletter__title text-uppercase">{{"newsletter"|translate}}</h5> -->
        <div class="footer-newsletter__text">
            {{"subscribe_to_newsletter"|translate}}
        </div>

        <form action="" class="footer-newsletter__form">
            <label class="sr-only" for="footer-newsletter-address">{{"your_email_address"|translate}}</label>
            <input [formControl]="email" type="text" class="footer-newsletter__form-input form-control"
                id="footer-newsletter-address" [attr.placeholder]="'your_email_address'|translate">

            <button (click)="subscribe()"
                class="footer-newsletter__form-button btn btn-danger">{{"subscribe"|translate}}</button>
        </form>
    </ng-container>

    <!-- <div  *ngIf="siteService.siteSetting && activeSocial"  class="footer-newsletter__text footer-newsletter__text--social">
        {{"follow_us"|translate}}
    </div>

    <app-social-links class="footer-newsletter__social-links" shape="circle"></app-social-links> -->
</div>



<!-- #DEP to be deprecated -->
<!-- <div class="footer-newsletter" *ngIf="!siteService.siteSetting?.socialMedia">
    <h5 class="footer-newsletter__title text-uppercase">{{"newsletter"|translate}}</h5>
    <div class="footer-newsletter__text">
        {{"subscribe_to_newsletter"|translate}}
    </div>

    <form action="" class="footer-newsletter__form">
        <label class="sr-only" for="footer-newsletter-address">{{"email_address"|translate}}</label>
        <input [formControl]="email" type="text" class="footer-newsletter__form-input form-control" id="footer-newsletter-address" [attr.placeholder]="'email_address'|translate">

        <button (click)="subscribe()"  class="footer-newsletter__form-button btn btn-primary">{{"subscribe"|translate}}</button>
    </form>

    <div class="footer-newsletter__text footer-newsletter__text--social">
        {{"follow_us"|translate}}
    </div>

    <app-social-links class="footer-newsletter__social-links" shape="circle"></app-social-links>
</div> -->
